import { IAccountManagementSegment } from '../../../types/entities/IAccountManagementSegment';
import { IAgency } from '../../../types/entities/IAgency';
import { IAgencyDescription } from '../../../types/entities/IAgencyDescription';
import {
    AccountManagementSegmentState,
    MemberState,
    ZinantisMemberDescriptionState,
} from '../../../types/zinantis/members/membersType';
import { getPastDate } from '../../../utils/formatDates';

export const adaptAccountManagmentSegmentsToState = (
    segments: IAccountManagementSegment[]
): AccountManagementSegmentState[] => {
    return segments.map(segment => ({
        id: segment?.Id || '',
        name:
            segment?.LocalizedCaption ||
            segment?.Caption ||
            segment?.Name ||
            '',
        key: segment?.Key || '',
    }));
};

export const adaptMembersToState = (members: IAgency[]): MemberState[] => {
    const twoMonthsAgo = getPastDate(2, 'month');
    return members.map(member => ({
        id: member?.Id || '',
        name: member?.Name || '',
        address: member?.Address || '',
        country:
            member?.Country?.LocalizedCaption ||
            member?.Country?.Caption ||
            member?.Country?.Name ||
            '',
        idCountry: member?.IdCountry || 0,
        countryCode: member?.Country?.ISO2 || '',
        logo: member?.LogoFile?.VirtualPath || '',
        idAccountManagmentSegment: member?.IdAccountManagementSegment || 0,
        accountManagmentSegment:
            member?.AccountManagementSegment?.LocalizedCaption ||
            member?.AccountManagementSegment?.Caption ||
            member?.AccountManagementSegment?.Name ||
            '',
        descriptions: [],
        hotels: [],
        signedDate: member?.ZinantisMemberDate || null,
        isNew:
            member?.ZinantisMemberDate &&
            new Date(member?.ZinantisMemberDate) >= new Date(twoMonthsAgo),
    }));
};

export const adaptMemberDescriptionToState = (
    description: IAgencyDescription
): ZinantisMemberDescriptionState => {
    return {
        id: description?.Id || '',
        description: description?.Description || '',
        idContentLanguage: description?.IdContentLanguage || 0,
        language:
            description?.ContentLanguage?.LocalizedCaption ||
            description?.ContentLanguage?.Caption ||
            description?.ContentLanguage?.Name ||
            '',
        code: description?.ContentLanguage?.CultureId || '',
    };
};
